import { render, staticRenderFns } from "./SelectImage.vue?vue&type=template&id=5255577a&scoped=true"
import script from "./SelectImage.vue?vue&type=script&lang=js"
export * from "./SelectImage.vue?vue&type=script&lang=js"
import style0 from "@/assets/stylesheets/components/personal-data/SelectImage.scss?vue&type=style&index=0&id=5255577a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255577a",
  null
  
)

export default component.exports